import { Events, animateScroll } from "react-scroll";

import type { LegCardIdClassAndFare } from "@app/constants/seat-selection-first";
import { OUTBOUND_LCF, RETURN_LCF } from "@app/constants/seat-selection-first";
import type { SegmentSelectedSeats } from "@app/modules/seat-selection-first/store";
import type { DeviceInfo } from "@app/types/device";

import type {
  NavigationState,
  SelectedSeatsBySegment
} from "../../hooks/use-navigation";
import type { History } from "history";

import {
  OPEN_DRAWER_KEY,
  VIEW_KEY,
  SEGMENT_ID_KEY,
  SELECTED_SEATS_KEY
} from "./constants";
import { PAGES } from "../../constants/pages";
import { formatSelectedSeatsToQueryParam } from "../selected-seats";

// TODO SSF this key should be merged with PAGES.SEAT_SELECTION
const SEAT_SELECTION_OPEN_DRAWER_KEY = "seat-selection";
export class SeatSelectionView {
  public static goTo(
    searchParams: URLSearchParams,
    leg_card_id_class_and_fare: LegCardIdClassAndFare,
    history: History<NavigationState>,
    device: DeviceInfo,
    is_roundtrip: boolean,
    segment_id: string
  ) {
    if (is_roundtrip) {
      searchParams.set(RETURN_LCF, leg_card_id_class_and_fare);
    } else {
      searchParams.set(OUTBOUND_LCF, leg_card_id_class_and_fare);
    }

    searchParams.set(SEGMENT_ID_KEY, segment_id);

    if (device.is_mobile) {
      searchParams.set(VIEW_KEY, PAGES.RESULTS);
      searchParams.set(OPEN_DRAWER_KEY, SEAT_SELECTION_OPEN_DRAWER_KEY);
      return history.push({
        search: searchParams.toString()
      });
    } else {
      searchParams.set(VIEW_KEY, PAGES.SEAT_SELECTION);

      Events.scrollEvent.register("end", () => {
        Events.scrollEvent.remove("end");
        history.push({
          search: searchParams.toString()
        });
      });

      animateScroll.scrollToTop({
        duration: 300
      });
    }
  }

  public static isCurrentlyViewed(
    searchParams: URLSearchParams,
    is_mobile: boolean
  ) {
    if (is_mobile) {
      return (
        searchParams.get(OPEN_DRAWER_KEY) === SEAT_SELECTION_OPEN_DRAWER_KEY
      );
    }

    return searchParams.get(VIEW_KEY) === PAGES.SEAT_SELECTION;
  }

  public static setSelectedSeatsQS(
    searchParams: URLSearchParams,
    selected_seats: SegmentSelectedSeats[] | number
  ) {
    let seats: number | SelectedSeatsBySegment =
      selected_seats as unknown as number;

    if (typeof selected_seats !== "number") {
      seats = formatSelectedSeatsToQueryParam(selected_seats);
    }

    searchParams.set(SELECTED_SEATS_KEY, JSON.stringify(seats));
  }
}
